/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Website_Draft_HiddenInputs */

const cs_blog_website_draft_hidden = /** @type {(inputs: Blog_Website_Draft_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koncepty a archivované články zůstávají jen v CRM a na web se neposílají.`)
};

const en_blog_website_draft_hidden = /** @type {(inputs: Blog_Website_Draft_HiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drafts and archived posts stay in the CRM only and are not sent to the website.`)
};

/**
* | output |
* | --- |
* | "Drafts and archived posts stay in the CRM only and are not sent to the website." |
*
* @param {Blog_Website_Draft_HiddenInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_website_draft_hidden = /** @type {((inputs?: Blog_Website_Draft_HiddenInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Website_Draft_HiddenInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_website_draft_hidden(inputs)
	return cs_blog_website_draft_hidden(inputs)
});